module.exports = __webpack_public_path__ + "static/media/NSS-1.ba52c7d5.png";